import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";

const Manuscript = () => {
  return (
    <Container>
      <h2 className="display-6 fw-bold my-4">Manuscript Submission & Instructions for Authors</h2>
      <hr />
     <div className="mx-md-4">
     <h4 className="fw-bold mb-2  " >1. Types of Articles</h4>
      <p className="joab-common-para mb-3">
        The Journal of Applied Bioanalysis accepts the following types of manuscripts:<br />
        - Original Research Articles<br />
        - Review Articles<br />
        - Short Communications<br />
        - Application Notes<br />
        - Letters to the Editor
      </p>

      <h4 className="fw-bold mb-2 " >2. Manuscript Format</h4>
      <p className="joab-common-para mb-3">
        <b>Language:</b> Manuscripts must be submitted in clear, grammatically correct English.<br />
        <b>File Type:</b> Microsoft Word (.doc/.docx)<br />
        <b>Font and Style:</b> Times New Roman, 12 pt, 1.5 spacing, 1-inch margins
      </p>
      <p className="joab-common-para mb-3">
        The manuscript should be structured as follows:
        <br />- Title Page with full author information
        <br />- Abstract (150–250 words) and 3–5 keywords
        <br />- Introduction
        <br />- Materials and Methods
        <br />- Results
        <br />- Discussion
        <br />- Conclusion
        <br />- Acknowledgments (if applicable)
        <br />- Conflict of Interest Statement
        <br />- References (Vancouver style)
      </p>

      <h4 className="fw-bold mb-2 " >3. Figures and Tables</h4>
      <p className="joab-common-para mb-3">
        Figures should be submitted in high resolution (minimum 300 DPI) in JPEG or PNG format. All figures and tables should be numbered sequentially and cited appropriately in the text. Provide captions below figures and above tables.
      </p>

      <h4 className="fw-bold mb-2 " >4. References</h4>
      <p className="joab-common-para mb-3">
        References must follow the Vancouver style.<br />
        <b>Examples:</b><br />
        Smith J, Doe A. Title of article. J Appl Bioanal. 2023;15(2):100–106.<br />
        Brown L. Bioanalysis in Practice. 2nd ed. Academic Press; 2021.
      </p>

      <h4 className="fw-bold mb-2 " >5. Plagiarism Policy</h4>
      <p className="joab-common-para mb-3">
        All manuscripts are screened using plagiarism detection tools. Manuscripts with more than 15% similarity will be rejected. The journal strictly adheres to COPE guidelines regarding plagiarism and ethical misconduct.
      </p>

      <h4 className="fw-bold mb-2 " >6. Ethical Approval</h4>
      <p className="joab-common-para mb-3">
        Research involving human participants or animals must include a statement of ethical approval from the appropriate committee. Informed consent must be obtained and clearly stated when applicable.
      </p>

      <h4 className="fw-bold mb-2 " >7. Open Access Policy</h4>
      <p className="joab-common-para mb-3">
        The Journal of Applied Bioanalysis is a fully Open Access journal. All content is freely available under the Creative Commons Attribution (CC BY) license.
      </p>

      <h4 className="fw-bold mb-2 " >8. Article Processing Charges (APC)</h4>
      <p className="joab-common-para mb-3">
        An article processing fee applies upon acceptance. Waivers or discounts may be available for authors from certain regions or institutions. Please contact the editorial office for more details.
      </p>

      <h4 className="fw-bold mb-2 " >9. Submission Process</h4>
      <p className="joab-common-para mb-3">
        Authors are encouraged to submit their manuscripts through our online submission portal:-   
        <b>
       
          <Link to="/submit-article" className="text-black">Submit Article</Link>
        </b>
        <br />
        If you experience any technical issues, you may alternatively submit your manuscript via email to:<br />
        <b>editor@journalofappliedbioanalysis.com</b>
      </p>
      <p className="joab-common-para mb-3">
        Please ensure the following are included:<br />
        - Cover Letter
        <a href="/CoverLetter.docx" download>
          <button type="button" className="btn btn-outline-primary btn-sm ms-2">Download</button>
        </a>
        <br />
        - Manuscript in Word format<br />
        - Figures and Tables (if separate)<br />
        - Author Declaration Form
        <a href="/AuthorDeclarationForm.docx" download>
          <button type="button" className="btn btn-outline-primary btn-sm ms-2">Download</button>
        </a>
      </p>

      <h4 className="fw-bold mb-2 " >10. Peer Review Process</h4>
      <p className="joab-common-para mb-3">
        All manuscripts undergo a double-blind peer review process. Authors can expect an initial decision within 2–3 weeks, and final decision including publication within 5–9 weeks, provided no major revisions are required.
      </p>

      <h4 className="fw-bold mb-2 " >11. English Editing Support</h4>
      <p className="joab-common-para mb-3">
        Authors are encouraged to use Green Publication's Author Services for English language editing. Discounts are available for accepted manuscripts.
      </p>

      <h4 className="fw-bold mb-2 " >12. Contact Information</h4>
      <p className="joab-common-para mb-3">
        For queries or assistance, please contact:<br />
        Email: editorial@journalofappliedbioanalysis.com<br />
        Website: <a href="www.journalofappliedbioanalysis.com">www.journalofappliedbioanalysis.com</a>
      </p>
     </div>
     
    </Container>
  );
};

export default Manuscript;
